import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "antd";
import { getFields } from "actions/fieldActions";
import { scrollToTop, validHscMarks } from "utils/generalHelpers";
import { ACTION_TYPES } from "reducers/actionTypes";
import { validSubjectNo, validAtar } from "utils/generalHelpers";
import "assets/stylesheets/FormControl.scss";

class FormControl extends Component {
  handleClickShow = () => {
    this.props.dispatch(getFields(this.buildApiUrl()));
  };

  clear = () => {
    scrollToTop();
    const { dispatch } = this.props;
    dispatch({
      type: ACTION_TYPES.state.reset,
    });
    dispatch({
      type: ACTION_TYPES.subjects.reset,
    });
    dispatch({ type: ACTION_TYPES.atar.reset });
    dispatch({ type: ACTION_TYPES.fields.reset });
    dispatch({ type: ACTION_TYPES.selectedFieldOfStudy.reset });
  };

  buildApiUrl = () => {
    const { atar, hscMarks, knowAtar, selectedSubjects } = this.props;
    const baseUrl = `course-compass-ws/api/${
      knowAtar ? "post_atar" : "pre_atar"
    }`;
    const subjectStringList = [];
    if (knowAtar) {
      Object.keys(hscMarks).forEach((key) => {
        subjectStringList.push(`${key}:${hscMarks[key]}`);
      });
    } else {
      for (var i = 0; i < selectedSubjects.length; i++) {
        subjectStringList.push(`${selectedSubjects[i].subject_id}`);
      }
    }

    return `${baseUrl}?atar=${atar}&subjects=${subjectStringList.join(",")}`;
  };

  render() {
    const { selectedSubjects, atar, hscMarks, knowAtar } = this.props;
    const validSubjectNumber = validSubjectNo(selectedSubjects);
    const validHscMarksInput = validHscMarks(
      knowAtar,
      selectedSubjects,
      hscMarks
    );
    const validAtarInput = validAtar(atar);

    const validInput =
      validSubjectNumber && validAtarInput && validHscMarksInput;
    return (
      <div className="form-control-container">
        <Button
          disabled={!validInput}
          className={
            validInput ? "form-button--primary" : "form-button--disabled"
          }
          onClick={() => {
            if (validInput) {
              this.handleClickShow();
            }
          }}
        >
          Show me the top fields of study
        </Button>
        <Button
          id="form-control-clear"
          className="form-button--secondary"
          onClick={this.clear}
        >
          Clear selection
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { atar } = store.atarReducer;
  const { knowAtar } = store.selectStateReducer;
  const { selectedSubjects, hscMarks } = store.selectSubjectsReducer;
  return {
    atar: atar,
    hscMarks: hscMarks,
    knowAtar: knowAtar,
    selectedSubjects: selectedSubjects,
  };
};

export default connect(mapStateToProps)(FormControl);
